import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Loadingcomponent from "../loader/loadingcomponent";
import { useMutation } from "react-query";
import { callQueryapi } from "../../services/http/callapi";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";

const MessageInputModal = ({
  show,
  toggleModal,
  data
}) => {
  console.log(data?.offerbaseprice, "data?.offerbaseprice")
  const [error, seterror] = useState("")
  const [numbers, setNumbers] = useState("")
  const { t } = useTranslation();
  const navigate = useNavigate()
  const customerprofile = useSelector(
    (state) => state?.userdata?.value?.customerprofile
  );
  useEffect(() => {
    if(show === false){
      setNumbers("")
      seterror("")
    }
  }, [show])
  
  console.log(customerprofile?.Msisdn === "965"+numbers, "customerprofileeee")
  const offerActive = useMutation(
    (req) =>
      callQueryapi({
        queryKey: ["", "/subscription/isofferactive", req],
      }),
    {
      onSuccess: (udata, variables, context) => {
        console.log(udata?.data?.status, "----udata")
        if(udata?.data?.status === "-1") {
          seterror(udata?.data?.message)
        }else if(udata?.data?.response?.metametaList?.ispurchaseallowed === true) {
      navigate('/pay',{
        state: { paytype: "gift", offerData: data, price: data?.offerbaseprice || '', fulfilment_msisdn : "965"+numbers},
      })
    }
      
      },
      onError: (uerror) => {
        console.log("=======OnError", uerror);
        throw new Error();
      },
    }
  );
  
  const handleContinue = () => {
    if(numbers === "" && error === ""){
      seterror(t("pemn"))
    } else if(customerprofile?.Msisdn === "965"+numbers){
      seterror(t("peavmn"))
    }else if(error === ""){
      offerActive.mutate({
        offerid:   data?.offerid,
        mode: 'gift',
        gmsisdn: "965"+numbers,
        type: data?.numtype,
      })
    }
 
  }
  const ChangeHandler = (e) => {
    if (e.target.value?.length > 8) {
      seterror(t("pemn"))
    } else if (e.target.value.match(/^[0-9]*$/)) {
      seterror("");
        setNumbers(e.target.value)
    }
  };
  return (
    <Modal
      show={show}
      backdrop={"true"}
      onHide={toggleModal}
      className="bottom_modal animated  slideInUp faster"
    >
      <Modal.Body>
        <div className="modal_img mb-4 text-center">
          <img
            src={process.env.PUBLIC_URL + "/assets/images/confirm_popup.svg"}
            width={60}
            alt=""
            title=""
          />
        </div>
        <div class="form-group mb-4 mt-4">
          <label class="control-label text-left">{data?.plantypelable}</label>
          <div class="input_icon right-icon">
            <input
             type="text"
              maxlength="8"
              name="msisdn"
              value={numbers}
              onWheel={(event) => event.currentTarget.blur()}
              onKeyDown={
                (evt) =>
                  (evt.key === 'e' || evt.key === '.') &&
                  evt.preventDefault()}
              onChange={(e) => {
                ChangeHandler(e);
              }}
              class="form-control"
              // placeholder={t("mobile_number")}
            />
            
          </div>
          {error && <p className="text-danger">{error}</p>}
        </div>

        <button
          type="button"
          className= {offerActive?.isLoading  ?"custom_btn custom_btn_primary btn_block disabled" : "custom_btn custom_btn_primary btn_block"}
          data-bs-dismiss="modal"
          onClick={offerActive?.isLoading ? "" : handleContinue}
        >
          {offerActive?.isLoading ? <Loadingcomponent /> : t("continue")}
        </button>
      </Modal.Body>
    </Modal>
  );

};
export default MessageInputModal;